import { useCurrentIdentityInfo } from "../../AuthWrapper2/hooks/useCurrentIdentityInfo.js";
import { RegionPickerMobile } from "../../AppWrapper2/components/AppNav/components/RegionPickerMobile.js";
import { AppPickerMobile } from "../../AppWrapper2/components/AppNav/components/AppPickerMobile.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Organizations/screens/OrganizationSidebarScreen.tsx
function OrganizationSidebarScreen({}) {
	const showRegions = useCurrentIdentityInfo().regions.length > 1;
	return /* @__PURE__ */ jsxs("div", {
		className: "p-base flex h-full grow flex-col",
		children: [showRegions && /* @__PURE__ */ jsxs("div", {
			className: "mb-lg flex flex-col",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle font-bold uppercase tracking-wider",
				children: "Regions"
			}), /* @__PURE__ */ jsx("div", {
				className: "mt-sm",
				children: /* @__PURE__ */ jsx(RegionPickerMobile, {})
			})]
		}), /* @__PURE__ */ jsxs("div", {
			className: "mb-lg flex grow flex-col overflow-y-auto",
			children: [/* @__PURE__ */ jsx("div", {
				className: "mb-sm text-color-subtle font-bold uppercase tracking-wider",
				children: "Apps"
			}), /* @__PURE__ */ jsx(AppPickerMobile, {})]
		})]
	});
}
export { OrganizationSidebarScreen };

//# sourceMappingURL=OrganizationSidebarScreen.js.map